import "../styles/index.scss"
import React from "react"

// import AllPost from "../components/post/allPost"
import homeImage from "../images/web-cover.jpg"
import Layout from "../components/core/layout"
import SEO from "../components/Features/seo"
import StickyPost from "../components/post/stickyPost"
import { AllStickyPost } from "../hooks/StickyQuery"
import HomeCatInternational from "../components/post/homeCatInternational"
import HomeCatEducation from "../components/post/homeCatEducation"
import HomeCatTechology from "../components/post/homeCatTechnology"
// import HomeCatMovies from "../components/post/homeCatMovies"
// import HomeCatSlider from "../components/post/homeCatSlider"

import ShareButtons from "../components/Features/sharebuttons"
const IndexPage = () => {
  const { edges } = AllStickyPost()
  return (
    <Layout>
      <SEO title="Home | Freelancology" slug="" />
      <StickyPost post={edges} />
      <div className="rowHome">
        <HomeCatInternational
          slug="international"
          category="International"
          headLine="International News & Updates"
        />
        {/* <HomeCatSlider
          slug="sports"
          category="Sports"
          headLine="Sports News & Updates"
        />
        <HomeCatSlider
          slug="movies-and-shobiz"
          category="movies and shobiz"
          headLine="Movies & Showbiz Updates"
        /> */}
        <HomeCatEducation
          slug="education"
          category="Education"
          headLine="Education Articles"
        />
        <HomeCatTechology
          slug="technologies"
          category="Technology"
          headLine="Technology Upadates"
        />
        <div className="bg-white">
          <ShareButtons
            title="Home Page"
            url="https://freelancology.com"
            image={homeImage}
            twitterHandle="Home Freelancology News Shobiz Sports Mobile Packages new Techniques"
            tags="#Home #Freelancology #News #Shobiz #Sports #Mobile #Packages_new #Techniques"
          />
        </div>
        {/* <AllPost /> */}
      </div>
    </Layout>
  )
}

export default IndexPage
